import {
  Sidebar,
  SidebarHeader,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail
} from "@/components/ui/sidebar";

function getVersion() {
  try {
    return process.env.BUILD_NUMBER;
  } catch {
    return "Dev";
  }
}

export function AppSidebar() {

  const version = getVersion();

  return (
    <Sidebar variant="sidebar" side="left">
      <SidebarHeader>
        <div className="flex flex-col items-start gap-2">
          <img src="/public/og-image.png" alt="Mathify Logo" width="100%" height={48}></img>
          <div className="relative left-27 top-[-3em] text-gray-500 text-xs">v{version}</div>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Main</SidebarGroupLabel>
          <SidebarGroupContent></SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
